import Search from "./components/Search.svelte";
import Cart from "./components/Cart.svelte";
import Business from "./components/Business.svelte";
import Admin from "./components/Admin.svelte";
import Contact from "./components/Contact.svelte";
import Eula from "./components/Eula.svelte";
import EditMenu from "./components/EditMenu.svelte";
import Graphs from "./components/Graphs.svelte";
import EditLoyalty from "./components/EditLoyalty.svelte";
import Dashboard from "./components/Dashboard.svelte";
import Main from "./components/Main.svelte";
import LoyaltyCards from "./components/LoyaltyCards.svelte";

export const routes = {
  "/": Main,
  // "/s/": Search,
  "/cart/*": Cart,
  "/b/:code": Business,
  "/admin/:code": Admin,
  "/admin/:code/Graphs/": Graphs,
  "/admin/:code/EditMenu/": EditMenu,
  "/admin/:code/EditMenu/EditItem/:sectionIdx/:itemIdx": EditMenu,
  "/admin/:code/EditMenu/New/:sectionIdx": EditMenu,
  "/admin/:code/EditLoyalty/": EditLoyalty,
  "/contact": Contact,
  "/eula": Eula,
  "/dashboard": Dashboard,
  "/LoyaltyCards": LoyaltyCards,
};
